import { useTranslation } from "react-i18next";

type Component = {
  slug: string;
  name: string;
};

export const useSeverityGridSamplePreview = () => {
  const { t } = useTranslation();

  const mainLevelLabel = t("form:staticField.component.mainLevelSample");
  const subComponentLabel = t("form:staticField.component.subLevelSample");

  const buildComponent = (index: number, label: string): Component => ({
    slug: `${index}`,
    name: `${label} ${index}`,
  });

  return [
    {
      ...buildComponent(1, mainLevelLabel),
      components: [
        buildComponent(1, subComponentLabel),
        buildComponent(2, subComponentLabel),
        buildComponent(3, subComponentLabel),
      ],
    },
    buildComponent(2, mainLevelLabel),
    buildComponent(3, mainLevelLabel),
    buildComponent(4, mainLevelLabel),
  ];
};
